import { useEffect, useCallback, useState } from 'react';
import { keepAliveService } from '../services/keepAlive';

interface KeepAliveStatus {
  isActive: boolean;
  lastPingTime: Date | null;
  pingInterval: number;
  businessHoursOnly: boolean;
}

export const useKeepAlive = () => {
  const [status, setStatus] = useState<KeepAliveStatus>(keepAliveService.getStatus());

  // Update status when component mounts
  useEffect(() => {
    const updateStatus = () => setStatus(keepAliveService.getStatus());
    
    // Update status every minute
    const interval = setInterval(updateStatus, 60000);
    
    return () => clearInterval(interval);
  }, []);

  const warmupBackend = useCallback(async () => {
    return await keepAliveService.warmup();
  }, []);

  const updateConfig = useCallback((config: {
    pingInterval?: number;
    enableLogging?: boolean;
    businessHoursOnly?: boolean;
  }) => {
    keepAliveService.updateConfig(config);
    setStatus(keepAliveService.getStatus());
  }, []);

  return {
    status,
    warmupBackend,
    updateConfig,
  };
}; 